import * as yup from 'yup';

import { DRIVER_FIELDS } from 'store/insuranceAnketa/constants';
import { FIELDS } from 'store/insuranceCalculation/constants';

import { VALIDATION_TYPES, VOID_VALIDATION } from '../../Insurance.constants';
import {
  CUSTOMER_BIRTHDATE_SCHEMA,
  CUSTOMER_DRIVING_EXPERIENCE_SCHEMA,
  CUSTOMER_DRIVING_LICENSE_ISSUE_DATE_SCHEMA,
  CUSTOMER_DRIVING_LICENSE_SERIES_AND_NUMBER_SCHEMA,
  CUSTOMER_FULL_NAME_SCHEMA,
} from '../../Insurance.validation';

export const VALIDATION_KEYS = {
  DRIVERS: 'drivers',
  MULTIDRIVE: 'multidrive',
  MULTIDRIVE_DATA: 'multidriveData',
};

export const driverSchema = yup.object().shape({
  [DRIVER_FIELDS.BIRTHDATE]: CUSTOMER_BIRTHDATE_SCHEMA.clone(),
  [DRIVER_FIELDS.DRIVING_EXPERIENCE]: CUSTOMER_DRIVING_EXPERIENCE_SCHEMA.clone(),
  [DRIVER_FIELDS.DRIVING_LICENSE_ISSUE_DATE]: CUSTOMER_DRIVING_LICENSE_ISSUE_DATE_SCHEMA.clone(),
  [DRIVER_FIELDS.DRIVING_LICENSE_SERIES_AND_NUMBER]:
    CUSTOMER_DRIVING_LICENSE_SERIES_AND_NUMBER_SCHEMA.clone(),
  [DRIVER_FIELDS.FULL_NAME]: CUSTOMER_FULL_NAME_SCHEMA.clone(),
});

export const driversSchema = yup.object().shape({
  [VALIDATION_KEYS.DRIVERS]: yup.mixed().when(VALIDATION_KEYS.MULTIDRIVE, {
    is: false,
    then: yup
      .array()
      .compact(({ [DRIVER_FIELDS.IS_DELETED]: isDeleted }) => {
        return isDeleted;
      })
      .of(driverSchema.clone()),
    otherwise: VOID_VALIDATION,
  }),
  [VALIDATION_KEYS.MULTIDRIVE]: yup.boolean(),
  [VALIDATION_KEYS.MULTIDRIVE_DATA]: yup.mixed().when(VALIDATION_KEYS.MULTIDRIVE, {
    is: true,
    then: yup.object().shape({
      [FIELDS.MIN_DRIVERS_AGE]: yup
        .mixed()
        .test(VALIDATION_TYPES.REQUIRED, 'Введите минимальный возраст водителей', (value) => {
          return typeof value === 'number';
        })
        .test(VALIDATION_TYPES.INCORRECT, 'Минимальный возраст 18 лет', (value) => {
          return value >= 18;
        }),
      [FIELDS.MIN_DRIVERS_EXPERIENCE]: CUSTOMER_DRIVING_EXPERIENCE_SCHEMA.clone(),
    }),
    otherwise: VOID_VALIDATION,
  }),
});
